export default {
    PROD: import.meta.env.MODE === "production",
    STAGING: import.meta.env.MODE === "staging",
    DEV: import.meta.env.DEV,
    VITE_API_URL: import.meta.env.VITE_API_URL,
    VITE_CDN_BUCKET_PATH: import.meta.env.VITE_CDN_BUCKET_PATH,

    GRID_SPACING: 2.5,

    COUNTRIES: {
        AT: "Austria",
        BE: "Belgium",
        BG: "Bulgaria",
        BY: "Belarus",
        HR: "Croatia",
        CY: "Cyprus",
        CZ: "Czechia",
        DK: "Denmark",
        EE: "Estonia",
        FI: "Finland",
        FR: "France",
        GE: "Georgia",
        DE: "Germany",
        GR: "Greece",
        HU: "Hungary",
        IS: "Iceland",
        IE: "Ireland",
        IT: "Italy",
        LV: "Latvia",
        LI: "Liechtenstein",
        LT: "Lithuania",
        LU: "Luxembourg",
        MT: "Malta",
        NL: "Netherlands",
        NO: "Norway",
        PL: "Poland",
        PT: "Portugal",
        RO: "Romania",
        RU: "Russia",
        SK: "Slovakia",
        SI: "Slovenia",
        ES: "Spain",
        SE: "Sweden",
        CH: "Switzerland",
        GB: "United Kingdom",
    } as const,

    INDUSTRIES: [
        { title: "Alcoholic beverages industry", code: "AB" },
        { title: "Non-Alcoholic beverages industry", code: "NB" },
        { title: "Food and beverage industry", code: "FB" },
        { title: "Food industry", code: "FO" },
        { title: "Furniture industry", code: "FU" },
    ] as const,

    BUSINESS: ["producer", "importer", "distributor"] as const,

    ASSETS: {
        dippiLogo:
            import.meta.env.MODE === "production"
                ? "https://cdn.dippi.app/static/dippi-logo.png"
                : "https://cdn-staging.dippi.app/static/dippi-logo.png",
        defaultAvatar:
            import.meta.env.MODE === "production"
                ? "https://cdn.dippi.app/static/default-avatar.png"
                : "https://cdn-staging.dippi.app/static/default-avatar.png",
        defaultImageThumbnail:
            import.meta.env.MODE === "production"
                ? "https://cdn.dippi.app/static/product-default-image-thumbnail.png"
                : "https://cdn-staging.dippi.app/static/product-default-image-thumbnail.png",
        dippiLogo2:
            import.meta.env.MODE === "production"
                ? "https://cdn.dippi.app/static/business-card-dippi-logo.png"
                : "https://cdn-staging.dippi.app/static/business-card-dippi-logo.png",
        wineExpoGeorgiaLogo:
            import.meta.env.MODE === "production"
                ? "https://cdn.dippi.app/static/wine-expo-georgia-logo.png"
                : "https://cdn-staging.dippi.app/static/wine-expo-georgia-logo.png",
        wineExpoGeorgiaBackground:
            import.meta.env.MODE === "production"
                ? "https://cdn.dippi.app/static/wine-expo-georgia-background.png"
                : "https://cdn-staging.dippi.app/static/wine-expo-georgia-background.png",
        skinWineFestLogo:
            import.meta.env.MODE === "production"
                ? "https://cdn.dippi.app/static/skin-wine-fest-logo.png"
                : "https://cdn-staging.dippi.app/static/skin-wine-fest-logo.png",
        skinWineFestBackground:
            import.meta.env.MODE === "production"
                ? "https://cdn.dippi.app/static/skin-wine-fest-background.png"
                : "https://cdn-staging.dippi.app/static/skin-wine-fest-background.png",
    },
};
